import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76b954c3"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "table table-borderless w-max-content" }
const _hoisted_3 = { class: "position-sticky top-0" }
const _hoisted_4 = { class: "align-middle text-center" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["innerHTML"]

import { PropType, ref, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  props: {
  columns: Array as PropType<Array<{ field: string; name: string; classTh: string; sort?: boolean; maxWidth?: boolean; activeSort?: boolean }>>,
  data: Array as PropType<Array<{ field: any }>>,
  sortCells: Array,
  children: Element,
  pageOfNumber: {
    type: Number,
    default: 30,
  },

  curPage: {
    type: Number,
    default: 1,
  },
  idTable: String,
},
  emits: ['changeSort'],
  setup(__props, { emit }) {

const props = __props

const router = useRouter()
const route = useRoute()
const sortField = ref([])
const sortCurrent = ref(false)




watch(
  () => props.pageOfNumber,
  () => {
    scrollTop()
  }
)

watch(
  () => props.curPage,
  () => {
    scrollTop()
  }
)

const handleSort = (field) => {
  let fieldSort = []
  sortCurrent.value = true
  fieldSort[field] = sortField.value[field] === 'asc' ? 'desc' : 'asc'
  sortField.value = fieldSort
  emit('changeSort', sortField.value)
  scrollTop()
}

const scrollTop = () => {
  let element = document.querySelector('#' + props.idTable)
  element.scrollTop = 0
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "table-responsive scroll-table",
    id: __props.idTable
  }, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", _hoisted_3, [
        _createElementVNode("tr", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columns, ({ field, name, maxWidth, classTh, activeSort }, index) => {
            return (_openBlock(), _createElementBlock("th", {
              class: _normalizeClass([index === 0 ? 'border-top-radius' : '', index === __props.columns?.length - 1 ? 'border-left-radius' : '', classTh]),
              key: index
            }, [
              (__props.sortCells?.includes(field))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    onClick: _withModifiers(($event: any) => (handleSort(field)), ["prevent"]),
                    class: _normalizeClass(['cursor-pointer d-flex align-items-center justify-content-center'])
                  }, [
                    _createElementVNode("span", {
                      class: _normalizeClass(maxWidth ? 'wi-max-content' : ''),
                      innerHTML: name
                    }, null, 10, _hoisted_6),
                    _createElementVNode("span", {
                      class: _normalizeClass([sortField.value[field] && 'active-sort', sortField.value[field] === 'asc' ? 'down' : 'up', !sortCurrent.value && activeSort ? 'active-sort' : ''])
                    }, null, 2)
                  ], 8, _hoisted_5))
                : _createCommentVNode("", true),
              (!__props.sortCells?.includes(field))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(maxWidth ? 'wi-max-content' : '')
                  }, _toDisplayString(name), 3))
                : _createCommentVNode("", true)
            ], 2))
          }), 128))
        ])
      ]),
      _createElementVNode("tbody", null, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ])
  ], 8, _hoisted_1))
}
}

})